import React from 'react'
import { CircularProgress, makeStyles } from '@material-ui/core'
import {
  BASE_COLORS,
  ERROR_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'
import { FieldInfoNG } from 'asterX-UI/DataDisplay'
import {
  Timeline,
  TimelineConnector,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator
} from '@material-ui/lab'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  heading: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    color: GRAY_COLORS[700],
    marginBottom: 12
  },

  rootBoxDiv: {
    padding: 14,
    backgroundColor: BASE_COLORS.White,
    display: 'flex',
    flexDirection: 'row',
    gap: 64,
    borderRadius: 12,
    border: '1px solid ' + GRAY_COLORS[300]
  }
}))

const ContractInfo = ({ sumDKP = 0, paymentData = [], loading }) => {
  const getTotalAmount = () => {
    if (paymentData?.length > 0) {
      const totalPayAmtCredit = paymentData.reduce(
        (a, b) => a + (b.isDelete ? 0 : b?.payAmtCredit?.toString()?.toNum()),
        0
      )
      const totalPayDebtCredit = paymentData.reduce(
        (a, b) => a + (b.isDelete ? 0 : b?.payAmtDebet?.toString()?.toNum()),
        0
      )
      return Number(totalPayAmtCredit - totalPayDebtCredit)
    }
    return 0
  }
  const getDebt = () => {
    return sumDKP?.toString()?.toNum() - getTotalAmount()
  }
  const classes = useStyles()
  return (
    <>
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center'
          }}
        >
          <CircularProgress color={'primary'} />
        </div>
      ) : !!paymentData?.length ? (
        <div className={classes.root}>
          <div className={classes.heading}> Оплата</div>
          <div className={classes.rootBoxDiv}>
            <FieldInfoNG
              label={'Общая сумма:'}
              isVertical
              style={{
                fontSize: 16,
                fontWeight: 500,
                lineHeight: '24px',
                color: GRAY_COLORS[700]
              }}
            >
              {getTotalAmount().toString().thousandSeparator() + ' ₸'}
            </FieldInfoNG>
            <FieldInfoNG
              label={getDebt() > 0 ? 'Долг: ' : 'Переплата: '}
              isVertical
              style={{
                fontSize: 16,
                fontWeight: 500,
                lineHeight: '24px',
                color: getDebt() > 0 ? ERROR_COLORS[600] : WARNING_COLORS[500]
              }}
            >
              {getDebt().toString().thousandSeparator() + ' ₸'}
            </FieldInfoNG>
          </div>
          <Timeline
            align="left"
            style={{
              padding: 0
            }}
          >
            {Array.isArray(paymentData) &&
              paymentData?.map((data, index) => (
                <TimelineItem key={data?.payNo}>
                  <TimelineSeparator>
                    <TimelineDot
                      variant={'outlined'}
                      color={'primary'}
                      style={{
                        width: 15,
                        height: 15,
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 14,
                        fontWeight: 600,
                        color: PRIMARY_COLORS[700]
                      }}
                    >
                      {paymentData.length - index}
                    </TimelineDot>
                    {paymentData.length !== index + 1 && (
                      <TimelineConnector
                        style={{
                          backgroundColor: PRIMARY_COLORS[700]
                        }}
                      />
                    )}
                  </TimelineSeparator>
                  <TimelineOppositeContent style={{ textAlign: 'left' }}>
                    <CardTime data={data} />
                  </TimelineOppositeContent>
                </TimelineItem>
              ))}
          </Timeline>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}
export default ContractInfo
const CardTime = ({ data }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <FieldInfoNG
        label={'Дата платежа:'}
        rootStyle={{
          alignItems: 'center'
        }}
        style={{
          fontSize: 12,
          fontWeight: 400
        }}
      >
        {data?.payDate
          ? new Date(data?.payDate).toLocaleString()
          : 'Нет данных'}
      </FieldInfoNG>{' '}
      <FieldInfoNG
        label={'Тип платежа:'}
        rootStyle={{
          alignItems: 'center'
        }}
        style={{
          fontSize: 12,
          fontWeight: 400
        }}
      >
        {data?.payType ? data?.payType : 'Нет данных'}
      </FieldInfoNG>{' '}
      <FieldInfoNG
        label={'Сумма:'}
        rootStyle={{
          alignItems: 'center'
        }}
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: !data.isDelete ? SUCCESS_COLORS[700] : ERROR_COLORS[700]
        }}
      >
        {data?.payAmtCredit === '0' || data?.payAmtCredit === 0
          ? '-' + data?.payAmtDebet?.toString()?.thousandSeparator() + ' ₸'
          : data?.payAmtCredit?.toString()?.thousandSeparator() + ' ₸'}
      </FieldInfoNG>
    </div>
  )
}
